/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const Contacts = (props: { className?: string }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_3307"
          data-name="Rectangle 3307"
          width="18"
          height="18"
          transform="translate(18.51 11.6)"
          fill="currentColor"
        />
      </clipPath>
    </defs>
    <g
      id="Groupe_de_masques_8"
      data-name="Groupe de masques 8"
      transform="translate(-18.51 -11.6)"
      clipPath="url(#clip-path)"
    >
      <g id="people-outline" transform="translate(17.914 11.002)">
        <path
          id="Tracé_6377"
          data-name="Tracé 6377"
          d="M15.07,6.3A2.743,2.743,0,0,1,12.6,9a2.741,2.741,0,0,1-2.474-2.7A2.408,2.408,0,0,1,12.6,3.6,2.422,2.422,0,0,1,15.07,6.3Z"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.2"
        />
        <path
          id="Tracé_6378"
          data-name="Tracé 6378"
          d="M12.6,11.4c-2.443,0-4.792,1.213-5.381,3.577a.476.476,0,0,0,.439.622h9.883a.477.477,0,0,0,.439-.622C17.388,12.572,15.039,11.4,12.6,11.4Z"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="1.2"
        />
        <path
          id="Tracé_6379"
          data-name="Tracé 6379"
          d="M7.5,6.97A2.221,2.221,0,0,1,5.511,9.147,2.22,2.22,0,0,1,3.524,6.97,1.944,1.944,0,0,1,5.511,4.8,1.955,1.955,0,0,1,7.5,6.97Z"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Tracé_6380"
          data-name="Tracé 6380"
          d="M7.722,11.471a5.251,5.251,0,0,0-2.212-.429,4.16,4.16,0,0,0-4.3,2.856.381.381,0,0,0,.351.5H5.773"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.2"
        />
      </g>
    </g>
  </svg>
);

export { Contacts };
